function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a3a9ad;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,0H1.81L5.32,6.37h0L8.86,0h1.81V10.65H8.86V3.52h0L5.92,8.59H4.73L1.82,3.52h0v7.13H0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M12.68,1.12a1.14,1.14,0,0,1,2.27,0,1.14,1.14,0,0,1-2.27,0ZM13,3.33h1.68v7.32H13Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M18.83,6.91,16.27,3.33h1.95l1.54,2.31h0l1.58-2.31H23.3l-2.55,3.6,2.6,3.72H21.47L19.81,8.34h0l-1.68,2.31H16.25Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M35.89,7.39a3.45,3.45,0,0,1-3.68,3.38c-2.05,0-3.67-1.64-3.67-4.15A6.53,6.53,0,0,1,33.89,0l.56,1.45a5.23,5.23,0,0,0-3.84,3.11l0,0a3.9,3.9,0,0,1,2-.54A3.08,3.08,0,0,1,35.89,7.39Zm-1.74,0a1.72,1.72,0,0,0-1.89-1.72,2.62,2.62,0,0,0-2,1v.14a2.17,2.17,0,0,0,2.1,2.32A1.77,1.77,0,0,0,34.15,7.37Z"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 40.88,
  y: 4.63,
  width: 12,
  height: 2,
  transform: "translate(8.76 33.49) rotate(-43)"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "52.27 9.72 50.27 9.72 50.27 2.54 42.49 2.54 42.49 0.54 52.27 0.54 52.27 9.72"
});

function SvgMixButtons06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 52.27 10.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixButtons06);
export default __webpack_public_path__ + "static/media/Mix_Buttons-06.c98e871e.svg";
export { ForwardRef as ReactComponent };